export const dashboard = {
  title: 'Dashboard',
  welcome: 'Welcome to %{companyName} Admin Console',
  vsYesterday: 'vs yesterday',
  stats: {
    totalSites: 'Total Sites',
    totalChargers: 'Total Chargers',
    activeChargers: 'Active Chargers',
    chargingSessions: 'Charging Sessions',
    sessionsToday: 'Sessions Today',
    totalUsers: 'Total Users',
    todayTransactions: "Today's Transactions",
    todayRevenue: 'Revenue Today',
    totalRevenue: 'Total Revenue',
    energyDelivered: 'Energy Delivered',
    activeSessions: 'Active Sessions',
    liveNow: 'Live now',
    accessible: 'Accessible',
  },
  chargerStatus: {
    title: 'Charger Status',
    available: 'Available',
    charging: 'Charging',
    offline: 'Offline',
    faulted: 'Faulted',
    other: 'Other',
    networkHealth: 'Network Health',
    needsAttention: 'charger(s) need attention',
  },
  recentSessions: {
    title: 'Recent Completed Sessions',
    subtitle: 'Latest charging sessions across your network',
    noSessions: 'No recent sessions found',
    duration: 'Duration',
    energy: 'Energy',
    revenue: 'Revenue',
  },
};
